import { all, put, takeEvery, fork } from "redux-saga/effects";
import { apiURL } from "../actions/helpers";
import axios from "axios";

// Action Types
export const WEALTH_RECENT_REBALANCES_LOAD = "WRR/LOAD";
export const WEALTH_RECENT_REBALANCES_LOAD_SUCCESS = "WRR/LOAD/SUCCESS";
export const WEALTH_RECENT_REBALANCES_LOAD_FAILURE = "WRR/LOAD/FAILURE";

// Action Creators
export const wealthRecentRebalancesLoad = (tier) => ({
  type: WEALTH_RECENT_REBALANCES_LOAD,
  tier,
});

export const wealthRecentRebalancesLoadSuccess = (data, tier) => ({
  type: WEALTH_RECENT_REBALANCES_LOAD_SUCCESS,
  data,
  tier,
});

export const wealthRecentRebalancesLoadFailure = (error, tier) => ({
  type: WEALTH_RECENT_REBALANCES_LOAD_FAILURE,
  error,
  tier,
});

// Sagas
function* fetchWealthRecentRebalances(action) {
  try {
    const { tier } = action;

    const response = yield axios.get(
      `${apiURL}/wealth-series/portfolios/recent-rebalances?tier=${tier}`,
      { withCredentials: true },
    );

    yield put(wealthRecentRebalancesLoadSuccess(response.data, tier));
  } catch (error) {
    yield put(wealthRecentRebalancesLoadFailure(error));
  }
}

function* listenWealthRecentRebalancesLoad() {
  yield takeEvery(WEALTH_RECENT_REBALANCES_LOAD, fetchWealthRecentRebalances);
}

// Root Saga
export function* saga() {
  yield all([fork(listenWealthRecentRebalancesLoad)]);
}

const INIT_STATE = {
  recentRebalances: {},
  loading: {},
  error: {},
};

// Reducer
const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case WEALTH_RECENT_REBALANCES_LOAD:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.tier]: true,
        },
        error: {
          ...state.error,
          [action.tier]: null,
        },
      };
    case WEALTH_RECENT_REBALANCES_LOAD_SUCCESS:
      return {
        ...state,
        recentRebalances: {
          ...state.recentRebalances,
          [action.tier]: action.data,
        },
        loading: {
          ...state.loading,
          [action.tier]: false,
        },
        error: {
          ...state.error,
          [action.tier]: null,
        },
      };
    case WEALTH_RECENT_REBALANCES_LOAD_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.tier]: false,
        },
        error: {
          ...state.error,
          [action.tier]: action.error,
        },
      };
    default:
      return state;
  }
};

export default reducer;
